import { firestore } from 'firebase/app';
import { getFirebase } from 'react-redux-firebase';
import { toastr } from 'react-redux-toastr';
import { closeModal } from '../../common/modals/modalActions';

export const addNewAgent = agent => {
  return async (dispatch, getState, { getFirestore }) => {
    const firebase = getFirebase();
    const user = getState().firebase.profile;
    console.log(agent);

    let createdBy = {
      role: user.role,
      name: user.displayName,
      uid: user.uid
    };

    agent.createdBy = createdBy;

    try {
      await firebase
        .push(`agents`, agent)
        .then(() => {
          toastr.success('Success', 'Agent will be processed.');
          dispatch(closeModal());
        })
        .catch(error => {
          console.error(error);
          toastr.error('Failed', 'Agent was not added');
        });
    } catch (error) {}
  };
};

export const deleteAgent = agent => {
  return async (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();

    try {
      await firestore
        .collection('agents')
        .doc(agent.uid)
        .delete()
        .then(() => {
          toastr.success('Success', 'Agent was added');
        })
        .catch(error => {
          console.error(error);
          toastr.error('Failed', 'Agent was not added');
        });
    } catch (error) {}
  };
};

export const addContact = (agent, company) => {
  return async (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();
    const user = getState().firebase.profile;

    agent.createdBy = {
      name: user.displayName,
      uid: user.uid,
      role: user.role
    };

    try {
      await firestore
        .collection('companies')
        .doc(company.id)
        .update({ ['contactPersons']: firestore.FieldValue.arrayUnion(agent) })
        .then(data => {
          //console.log(data);
          toastr.success('Success', 'Contact has been added to contacts');
          // dispatch(closeModal());
        });
    } catch (error) {
      console.error(error);
      toastr.error('Failed', 'Contact was not added');
    }
  };
};

export const updateCompany = company => {
  return async (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();
    const user = getState().firebase.profile;

    let isNew = false;

    if (company && company.id === undefined) {
      const id = firestore.collection('companies').doc().id;
      company.id = id;
      isNew = true;
      const createdBy = {
        name: user.displayName,
        uid: user.uid,
        role: user.role,
        date: new Date()
      };
      company.createdBy = createdBy;
    }

    const updatedBy = {
      name: user.displayName,
      uid: user.uid,
      role: user.role,
      date: new Date()
    };

    let updates = [];
    if (company.updatedBy && company.updatedBy.length > 0) {
      updates = company.updatedBy;
    }

    updates.push(updatedBy);

    company.updatedBy = updates;

    try {
      await firestore
        .collection('companies')
        .doc(company.id)
        .set(company, { merge: true })
        .then(data => {
          //console.log(data);
          if (isNew) {
            dispatch(closeModal());
          }

          toastr.success('Success', 'Company profile has been updated');
        })
        .catch(err => {
          //console.log(err);
        });
    } catch (error) {
      console.error(error);
      toastr.error('Failed', 'Company profile update failed');
    }
  };
};

export const deleteCompany = company => {
  return async (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();

    let confirmation = window.confirm('Are you sure to delete this company? ');

    if (confirmation) {
      dispatch(closeModal());
      await firestore
        .collection('companies')
        .doc(company.id)
        .delete()
        .then(() => {
          dispatch(closeModal());
          toastr.success('Success', 'Company was deleted');
        })
        .catch(error => {
          console.error(error);
          toastr.error('Failed', 'Company  was not deleted');
        });
    }
  };
};
